exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.app-footer[data-v-4686bd8d]{position:fixed;bottom:0;z-index:50000;text-transform:uppercase\n}\n.app-footer nav ul[data-v-4686bd8d]{margin-left:0\n}\n.app-footer nav ul li[data-v-4686bd8d]{border-left-color:white !important\n}\n", ""]);




//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4686bd8d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"includePaths":["/home/runner/work/parks-rec-finder/parks-rec-finder/node_modules/foundation-sites/scss"]}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"/home/runner/work/parks-rec-finder/parks-rec-finder/src/style/_variables.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SiteFooter.vue
// module id = 493
// module chunks = 0